import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const InfluencersPage = lazy(() => import('@/pages/influencers'));

export const Route = createFileRoute('/influencers')({
  component: function InfluencersRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <InfluencersPage />
      </Suspense>
    );
  },
});
